import React from 'react';
import { X } from 'lucide-react';
import './CustomModal.css';

export default function CustomModal({ open, onClose, children }) {
  if (!open) return null;
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-content">
        <button className="custom-modal-close" onClick={onClose}>
          <X />
        </button>
        {children}
      </div>
    </div>
  );
}
